import { Box, Dialog, DialogTitle, IconButton, Paper, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";

const FilePreview = ({ filePreview, onToggleModal }) => {
    const [file, setfile] = useState(filePreview?.data)
    const [pdfBlobUrl, setPdfBlobUrl] = useState(null)

    const getFileType = (fileName) => {
        const ext = fileName.split(".").pop().toLowerCase();
        if (["png", "jpg", "jpeg", "gif", "bmp", "webp"].includes(ext)) return "image";
        if (ext === "pdf") return "pdf";
        if (["doc", "docx","xlsx", "xls", "csv"].includes(ext)) return "excel";
        // if (["doc", "docx"].includes(ext)) return "word";
        return "other";
    }
    const fileType = getFileType(file?.file_name);

    useEffect(() => {
        const rawUrl = file?.presigned_url || file?.download_url;
        if (!rawUrl || fileType !== "pdf") return;

        let objectUrl;
        fetch(rawUrl)
            .then(res => res.blob())
            .then(blob => {
                objectUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                setPdfBlobUrl(objectUrl);
            })
            .catch(() => setPdfBlobUrl(rawUrl));

        return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
    }, [file?.presigned_url, file?.download_url]);
    return (
        <Dialog open={filePreview?.modal} fullScreen>
            <DialogTitle dividers >
            <Box display="flex">
                    <Typography sx={{ flexGrow: 1 }} variant="h6">
                        {file?.file_name}
                    </Typography>
                    <IconButton color="inherit" onClick={onToggleModal}>
                        <CloseIcon />
                    </IconButton>
            </Box>
            </DialogTitle>
            <Paper sx={{ height: "91.7%", display: "flex", alignItems: "center", justifyContent: "center", background:'#edebeb' }} square>
                {fileType === "image" && (
                    <img src={file?.presigned_url ? file?.presigned_url : file?.download_url} alt={file?.file_name} style={{ maxWidth: "95%", maxHeight: "95%", objectFit:'inherit', }} />
                )}

                {fileType === "pdf" && pdfBlobUrl && (
                    <iframe src={pdfBlobUrl} title={file?.file_name} width="100%" height="100%" style={{ border: "none" }} />
                )}
                {fileType === "pdf" && !pdfBlobUrl && (
                    <Typography color="text.secondary">Loading PDF...</Typography>
                )}

                {fileType === "excel" && (
                    <iframe
                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent( file?.presigned_url ? file?.presigned_url : file?.download_url )}`}
                        title={file?.file_name}
                        width="100%"
                        height="100%"
                        style={{ border: "none" }}
                    />
                )}
                {(fileType === "word" || fileType === "other") && (
                    <Typography color="text.secondary">
                        Preview not available for this file type.
                    </Typography>
                )}
            </Paper>
        </Dialog>
    );
}
export default FilePreview;